import { Pipe, PipeTransform } from '@angular/core';
import { IReferralProgramChoiceInfo } from 'app/core/services/mainapp/multiplePathways';

@Pipe({ name: 'pendingApproval' })

export class PendingApprovalPipe implements PipeTransform {
    transform(data: IReferralProgramChoiceInfo[]) {
        if (data == null) return null;
        
        return data.forEach(pgm => pgm.PendingApproval === true);
    }
}